import * as React from 'react';
import { Link } from 'react-router-dom';
import { routeConstants } from 'app/routes/route-constants';
import { IntlShape } from 'react-intl';
import { formatDate } from '../utils';
import { CaseDraftsMeatball } from './case-drafts-table-meatball';
import { MyCaseDraftsTranslation } from 'app/area/my-case-drafts/constants';
import { CaseDraftRow } from 'app/area/my-case-drafts/types-store';
import styles from './case-drafts-table.scss';

interface CaseDraftsTableMobileProps {
  rows: CaseDraftRow[];
  onDelete: (draftId: number) => void;
  translation: MyCaseDraftsTranslation;
  intl: IntlShape;
}

type FieldDef = { label: string; render: (row: CaseDraftRow) => React.ReactNode };

const buildFields = (translation: MyCaseDraftsTranslation, intl: IntlShape): FieldDef[] => [
  {
    label: translation.my_case_drafts_id,
    render: row => (
      <Link to={routeConstants.draftViewFor(row.draftId)} className={styles.draftIdLink} target="_blank" rel="noreferrer">
        {row.draftId}
      </Link>
    )
  },
  { label: translation.my_case_drafts_case_type, render: row => row.caseType?.d ?? '' },
  { label: translation.my_case_drafts_last_modified_date, render: row => formatDate(row.modifiedDate, intl) },
  { label: translation.my_case_drafts_title, render: row => row.caseTitle },
  { label: translation.my_case_drafts_description, render: row => row.caseDescription },
  { label: translation.my_case_drafts_case_date, render: row => formatDate(row.caseDate, intl) }
];

export const CaseDraftsTableMobile = React.memo(({ rows, onDelete, translation, intl }: CaseDraftsTableMobileProps) => {
  const fields = buildFields(translation, intl);
  return (
    <table>
      {rows.map(row => (
        <tbody key={row.draftId}>
          <tr>
            <th colSpan={2}>
              <div>
                <span className={styles.draftTag}>{translation.my_case_drafts_tag}</span>
                <CaseDraftsMeatball draftId={row.draftId} onDelete={onDelete} translation={translation} />
              </div>
            </th>
          </tr>
          {fields.map(field => (
            <tr key={field.label}>
              <th>{field.label}</th>
              <td>{field.render(row)}</td>
            </tr>
          ))}
        </tbody>
      ))}
    </table>
  );
});
